import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const ConfirmationDialog = (props) => {
  const handleClose = () => {
    props.close();
  };

  // Determine which type of dialog to show
  const isPaymentDialog = props.type === 'payment';
  const isEnrollmentDialog = props.type === 'enrollment';

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth={props.size || 'sm'}
      sx={{ '& .MuiDialog-paper': { width: '100%' } }}>
      <DialogTitle sx={{ pb: 2 }}>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>{props.alert}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        {isPaymentDialog && (
          <>
            <Button
              onClick={props.programPaying ? props.runSwitchToSelfPay : props.runSwitchToProgramPay}
              fullWidth={props.fullWidth || false}
              variant={props.variant || 'contained'}
              color="secondary"
              sx={{ flex: props.fullWidth ? 1 : 'none' }}>
              {props.programPaying ? 'Switch to Self Pay' : 'Switch to Program Pay'}
            </Button>
            <Button
              onClick={handleClose}
              fullWidth={props.fullWidth || false}
              variant={props.variant || 'text'}
              color="primary"
              sx={{ flex: props.fullWidth ? 1 : 'none' }}>
              Cancel
            </Button>
          </>
        )}
        {isEnrollmentDialog && (
          <>
            <Button
              onClick={props.dxFromProgram ? props.runReEnroll : props.runDischarge}
              fullWidth={props.fullWidth || false}
              variant={props.variant || 'contained'}
              color="secondary"
              sx={{ flex: props.fullWidth ? 1 : 'none' }}>
              {props.dxFromProgram ? 'Re-Enroll Member' : 'Discharge Member'}
            </Button>
            <Button
              onClick={handleClose}
              fullWidth={props.fullWidth || false}
              variant={props.variant || 'text'}
              color="primary"
              sx={{ flex: props.fullWidth ? 1 : 'none' }}>
              Cancel
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
